import store, { persistor } from "../store";
import { logoutSuccess, setCurrentPosition } from "../actions/allActions";
import { clearAuthTokens } from "./http";

export const clearPersistedSession = async () => {
  clearAuthTokens();
  await store.dispatch(logoutSuccess());
  store.dispatch(setCurrentPosition(null));
  await persistor.flush();
  await persistor.purge();
};
